import React from 'react';
import styles from './styles.module.css';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { anglesInPhotos, regionsInPhotos } from '../../modules/evolutionPhotos';

/**
 * Filtros da galeria: região (lista só com as regiões que o paciente tem
 * fotos) e ângulo (chips). Um filtro some quando nenhuma foto o usa.
 */
const EvolutionPhotoFilters = ({ photos, filters, onChange }) => {
  const regions = regionsInPhotos(photos);
  const angles = anglesInPhotos(photos);

  if (regions.length === 0 && angles.length === 0) return null;

  return (
    <div className={styles.filters}>
      {regions.length > 0 && (
        <FormControl size="small" sx={{ minWidth: 190 }}>
          <InputLabel id="evolution-photos-region-filter">Região</InputLabel>
          <Select
            labelId="evolution-photos-region-filter"
            label="Região"
            value={filters.region || ''}
            onChange={(event) => onChange({ ...filters, region: event.target.value })}
          >
            <MenuItem value="">Todas as regiões</MenuItem>
            {regions.map((region) => (
              <MenuItem key={region.key} value={region.key}>{region.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {angles.length > 0 && (
        <div className={styles.chips} role="radiogroup" aria-label="Ângulo">
          <button
            type="button"
            role="radio"
            aria-checked={!filters.angle}
            className={`${styles.chip} ${!filters.angle ? styles.chipActive : ''}`}
            onClick={() => onChange({ ...filters, angle: '' })}
          >
            Todos os ângulos
          </button>
          {angles.map((angle) => (
            <button
              key={angle.value}
              type="button"
              role="radio"
              aria-checked={filters.angle === angle.value}
              className={`${styles.chip} ${filters.angle === angle.value ? styles.chipActive : ''}`}
              onClick={() => onChange({ ...filters, angle: angle.value })}
            >
              {angle.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EvolutionPhotoFilters;
